import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	HostBinding,
	Input,
	Output,
	ViewEncapsulation,
} from "@angular/core";
import { OmsMessage } from "@obg/ngx.common";
import { coerceBoolean } from "@obg/ngx.global.evo";

@Component({
	selector: "obg-app-m-oms-summary-list",
	templateUrl: "./oms-summary-list.component.html",
	styleUrls: ["./oms-summary-list.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class OmsSummaryListComponent {
	@Input() messages: OmsMessage[] | undefined;
	@Input() showMoreCount: number | undefined;
	@Input() @coerceBoolean() busy: boolean | undefined;

	@Output() show = new EventEmitter<number | undefined>();

	@HostBinding("class.obg-m-oms-summary-list") class = true;

	trackByMessage(_index: number, message: OmsMessage) {
		return message.id;
	}
}
